import React, { Component } from 'react'
import request from '../../../lib/requester'
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import Autocomplete from '../../../component/autocomplete'
import { Link } from 'react-router-dom';
import _ from 'lodash'

class CustomerForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Customer_ID: '',
      Customer_Branch: '',
      Customer_Name: '',
      Customer_NPWP: '',
      Customer_NPWP_Name: '',
      Customer_NPWP_Address: '',
      Customer_Bank: '',
      Customer_Bank_Account_No: '',
      Customer_Bank_Account_Owner: '',
      Customer_PPh_Type: '',
      Customer_PPh_Rate: '0',
      Customer_PKP_Badan: '',
      Customer_Is_Exist: false,
      Customer_Channel: '',
      Customer_Group: '',
      Customer_Address: '',
      Customer_NIK: '',
      Customer_NIK_Address: '',
      Customer_Bank_Branch: '',
      Customer_Bank_BI_Code: '',
      Customer_Notes: '',
      Customer_Source_Flag: '',
      Customer_Status: '',
      Customer_Active: '',
      Customer_PIC: '',
      lovBank: [],
      success: '',
      error: [],
      lovBranch: [],
      fileContainer: { filename: '', path: '' },
      Loading: false,
      Is_Update: false,
      Lov_PPh_Type: [],
      User: JSON.parse(window.localStorage.getItem('is_user'))
    }
  }

  componentDidMount = () => {
    this.getMasterData()
    this.getBranch()
    this.getBank()
    let qs = this.props.location.search.replace("?", "")
    let id = ""
    if (qs.length > 0) {
      let qss = qs.split("=")
      id = qss[1]
    }
    if (id.length > 0) {
      this.getDetailCustomer(id)
    }
  }

  getBank = () => {
    let url = '/api/traces_chd/v1/customer/list-bank'
    request.getCHD(url, {
      success: function (response) {
        let { data } = response.data
        this.setState({ lovBank: data })
      }.bind(this),
      error: function (e) {
        console.log(e)
      }.bind(this)
    })
  }

  getBranch = () => {
    let url = '/arman/v1/general/organization'
    request.getArman(url, {
      success: function (response) {
        let { data } = response.data
        this.setState({ lovBranch: data })
      }.bind(this),
      error: function (e) {
        console.log(e)
      }.bind(this)
    })
  }

  getDetailCustomer = (id) => {
    console.log(id)
    let url = '/api/traces_chd/v1/customer/detail?id=' + id
    this.setState({ loading: true })
    request.getCHD(url, {
      success: function (response) {
        let { data } = response.data
        this.setState({
          loading: false,
          Customer_ID: data.customer_id,
          Customer_Branch: data.branch,
          Customer_Name: data.customer_name,
          Customer_NPWP: data.npwp,
          Customer_NPWP_Address: data.npwp_address,
          Customer_NPWP_Name: data.npwp_name,
          Customer_PPh_Rate: data.pph_rate,
          Customer_PPh_Type: data.pph_type,
          Customer_Bank: data.bank_name,
          Customer_Bank_Branch: data.bank_branch,
          Customer_Bank_BI_Code: data.bank_bi_code,
          Customer_NIK: data.nik,
          Customer_NIK_Address: data.nik_address,
          Customer_Bank_Account_No: data.bank_account_no,
          Customer_Bank_Account_Owner: data.bank_account_owner,
          Customer_PKP_Badan: data.pkp_badan,
          Customer_Notes: data.notes,
          Customer_Source_Flag: data.source_flag,
          Customer_Status: data.status,
          Customer_Active: data.is_active,
          Customer_Channel: data.channel,
          Customer_Group: data.customer_group,
          Customer_Address: data.customer_address,
          Customer_PIC: data.customer_pic,
          fileContainer: {
            filename: data.attachment_filename,
            path: data.attachment_path
          },
          Is_Update: true
        })

        document.getElementById('search-0').value = data.customer_name
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  getMasterData = () => {
    let url = '/api/traces_chd/v1/program/data-master'
    request.getCHD(url, {
      success: function (response) {
        let { ProgramPPhType } = response.data.data
        this.setState({
          Lov_PPh_Type: ProgramPPhType
        })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }
    })
  }

  handleChangeInput = (event) => {
    let { lovBank } = this.state
    let value = event.target.value;
    let name = event.target.name;

    this.setState({ [name]: value });
    if (name === 'Customer_Bank_BI_Code') {
      let find = _.find(lovBank, (o) => {
        return o.bank_bi_code === value
      })
      if (find) {
        console.log(find)
        this.setState({ Customer_Bank: find.bank_name })
      }
    }
  };

  renderLovPPhType = () => {
    return (
      <select className="form-control" name="Customer_PPh_Type" value={this.state.Customer_PPh_Type} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select PPh Type -</option>
        {
          this.state.Lov_PPh_Type.map((item, index) => (
            <option key={index} value={item.pph_type}>{item.pph_type}</option>
          ))
        }
      </select>
    )
  }

  isNumeric = (value) => {
    return /^\d+$/.test(value);
  };

  validationForm = () => {
    let errorMsg = []
    this.setState({ error: [] })

    if (this.state.Customer_ID === '') {
      errorMsg.push('Please select customer')
    }
    if (this.state.Customer_Name === '') {
      errorMsg.push('Customer Name is required')
    }
    if (this.state.Customer_Channel === '') {
      errorMsg.push('Customer Channel is required')
    }
    if (this.state.Customer_Group === '') {
      errorMsg.push('Customer Group is required')
    }
    if (!this.state.Customer_PIC) {
      errorMsg.push('Customer PIC (Nama Lengkap sesuai KTP) is required')
    }

    //NIK Validation
    if(!this.state.Customer_NIK) {
      errorMsg.push("Customer NIK is required");
    } else if(!this.isNumeric(this.state.Customer_NIK)) {
      errorMsg.push("Customer NIK must be in number");
    } else if(this.state.Customer_NIK.replace(/\s/g, '').length != 16) {
      errorMsg.push("Customer NIK must be in 16 digits");
    }

    if (!this.state.Customer_NIK_Address) {
      errorMsg.push('Customer NIK Address (Alamat sesuai KTP) is required')
    }

    
    if(!this.state.fileContainer.filename && !this.state.fileContainer.path){
      errorMsg.push('Upload Document is required')
    }

    this.setState({ error: errorMsg })
    return (errorMsg.length > 0) ? false : true
  }

  handleSubmit = () => {
    if (this.validationForm()) {
      let url = this.state.Is_Update ? '/api/traces_chd/v1/customer/update' : '/api/traces_chd/v1/customer/create'
      let param = {
        customer_id: this.state.Customer_ID,
        customer_name: this.state.Customer_Name?.toUpperCase() ?? this.state.Customer_Name,
        customer_channel: this.state.Customer_Channel?.toUpperCase() ?? this.state.Customer_Channel,
        customer_group: this.state.Customer_Group?.toUpperCase() ?? this.state.Customer_Group,
        customer_address: this.state.Customer_Address?.toUpperCase() ?? this.state.Customer_Address,
        customer_pic: this.state.Customer_PIC?.toUpperCase() ?? this.state.Customer_PIC,
        npwp: this.state.Customer_NPWP?.toUpperCase() ?? this.state.Customer_NPWP,
        npwp_name: this.state.Customer_NPWP_Name?.toUpperCase() ?? this.state.Customer_NPWP_Name,
        npwp_address: this.state.Customer_NPWP_Address?.toUpperCase() ?? this.state.Customer_NPWP_Address,
        pkp_badan: this.state.Customer_PKP_Badan,
        pph_type: this.state.Customer_PPh_Type,
        pph_rate: this.state.Customer_PPh_Rate,
        bank_name: this.state.Customer_Bank?.toUpperCase() ?? this.state.Customer_Bank,
        bank_account_no: this.state.Customer_Bank_Account_No,
        bank_account_owner: this.state.Customer_Bank_Account_Owner?.toUpperCase() ?? this.state.Customer_Bank_Account_Owner,
        created_by: this.state.User.user_id,
        fileContainer: this.state.fileContainer,
        // branch: this.state.User.org_name,
        branch: this.state.Customer_Branch?.toUpperCase() ?? this.state.Customer_Branch,
        nik: this.state.Customer_NIK.replace(/\s/g, ''),
        nik_address: this.state.Customer_NIK_Address?.toUpperCase() ?? this.state.Customer_NIK_Address,
        bank_branch: this.state.Customer_Bank_Branch?.toUpperCase() ?? this.state.Customer_Bank_Branch,
        bank_bi_code: this.state.Customer_Bank_BI_Code,
        notes: this.state.Customer_Notes?.toUpperCase() ?? this.state.Customer_Notes,
        source_flag: this.state.Customer_Source_Flag?.toUpperCase() ?? this.state.Customer_Source_Flag,
        status: (this.state.Customer_Status === 'R' || this.state.Customer_Status === '') ? 'D' : this.state.Customer_Status,
        requester: this.state.User.username
      }

      this.setState({ loading: true })
      request.postCHD(url, param, {
        success: function (response) {
          let { message } = response.data
          this.setState({ success: message, loading: false })
          window.scrollTo(0, 0)

          let app = this
          window.setTimeout(() => {
            app.props.history.push('/admin/setup/customer/list')
          }, 2000)
        }.bind(this),
        error: function (e) {
          this.setState({ loading: false })
        }.bind(this)
      })
    } else {
      window.scrollTo(0, 0)
    }
  }

  showNotification = () => {
    console.log(this.state.error)
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i className="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  onChangeAutocomplete = (description) => {
    let { User } = this.state
    let container = [];
    let param = {
      query: description,
      branch: User.branch
    };

    return new Promise((resolve) => {
      request.postCHD("/api/traces_chd/v1/customer/search", param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.CUSTOMER_DESC;
            item.value = item.CUSTOMER_ID;
            item.chanel = item.CHANNEL_OUTLET_GROUP_DESC_OTC;
            item.customer_group = item.CUSTOMER_GROUP_DESC;
            item.branch = item.BRANCH_ID;
            item.address = item.CUSTOMER_ADDRESS;
            return item;
          });
          resolve(container);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  }

  onSelectCustomer = (item, index) => {
    // check existing customer'
    let { User } = this.state
    let url = '/api/traces_chd/v1/customer/detail?id=' + item.value
    this.setState({ loading: true })
    request.getCHD(url, {
      success: function (response) {
        let { data } = response.data
        this.setState({
          loading: false,
          error: data.customer_id ? ['This customer is already on the list'] : [],
          Customer_Name: data.customer_id ? '' : item.text,
          Customer_ID: data.customer_id ? '' : item.value,
          Customer_Is_Exist: data.customer_id ? true : false,
          Customer_Channel: item.CHANNEL_OUTLET_GROUP_DESC_OTC,
          Customer_Group: item.CUSTOMER_GROUP_DESC,
          Customer_Source_Flag: item.SOURCE_FLAG,
          Customer_Branch: item.branch,
          Customer_Address: item.address
        })
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  handleUpload = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    let doctype = e.target.dataset.type;
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = ["jpg", "png", "jpeg", "gif", "doc", "docx", "xls", "xlsx", "csv", "pdf"];
    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobodyCHD("/api/traces_chd/v1/util/upload-file", data, {
      success: function (response) {
        let data = response.data;

        let { fileContainer } = this.state;
        fileContainer.filename = data.filename;
        fileContainer.path = data.fullurl;
        this.setState(fileContainer);
        this.setState({ loading: false });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
        console.log(e.message)
      }.bind(this),
    });
  };

  handleRemoveFile = () => {
    let { fileContainer } = this.state
    fileContainer.filename = ''
    fileContainer.path = ''
    this.setState(fileContainer)
  }

  renderAttachment = () => {
    let { fileContainer } = this.state
    if (fileContainer.filename && fileContainer.filename.length > 0) {
      return (
        <span>
          <a href={this.state.fileContainer.path}>{this.state.fileContainer.filename}</a> &nbsp; <button className="btn btn-danger rounded-circle" onClick={this.handleRemoveFile.bind(this)}><i className="fa fa-trash" /></button>
        </span>
      )
    } else {
      return (
        <input type="file" name="myFile" onChange={this.handleUpload.bind(this)} />
      )
    }
  }

  renderLovBranch = () => {
    let { lovBranch } = this.state
    return (
      <select className="form-control" disabled={true} name="Customer_Branch" value={this.state.Customer_Branch} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Branch -</option>
        {
          lovBranch.map((item, index) => (
            <option value={item.org_name}>{item.org_name}</option>
          ))
        }
      </select>
    )
  }

  renderLovBank = () => {
    let { lovBank } = this.state
    return (
      <select className="form-control" name="Customer_Bank_BI_Code" onChange={this.handleChangeInput.bind(this)} value={this.state.Customer_Bank_BI_Code}>
        <option value="">- Select Bank -</option>
        {
          lovBank.map((item, index) => (
            <option key={index} value={item.bank_bi_code}>{item.bank_name}</option>
          ))
        }
      </select>
    )
  }

  renderSubmitButton = () => {
    let { Customer_Status, Customer_Active } = this.state
    // Hanya muncul saat create awal, atau status reject, atau sudah active
    // if (Customer_Status === '' || Customer_Status === 'R' || Customer_Active === 'Y') {
      return (
        <div className="col-md-3">
          <button type="button" disabled={this.state.Customer_Is_Exist ? true : false} className="btn btn-primary btn-block" onClick={this.handleSubmit.bind(this)}><i className="fa fa-save" /> Save</button>
        </div>
      )
    // }
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-header">Form Customer</div>
                  <div className="card-body">
                    {this.showNotification()}
                    <form className="">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row mr-1">
                            <label>Customer Name</label>
                            <Autocomplete onchange={this.onChangeAutocomplete.bind(this)} isDisabled={this.state.Is_Update} onselect={this.onSelectCustomer.bind(this)} />
                          </div>
                          <div className="form-group row mr-1">
                            <label>Channel</label>
                            <input type="text" className="form-control" name="Customer_Channel" disabled={true} value={this.state.Customer_Channel} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row mr-1">
                            <label>Customer Group</label>
                            <input type="text" className="form-control" name="Customer_Group" disabled={true} value={this.state.Customer_Group} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row mr-1">
                            <label>Customer Address</label>
                            <textarea disabled className="form-control" rows={5} name="Customer_Address" value={this.state.Customer_Address}></textarea>
                          </div>
                          <div className="form-group row mr-1">
                            <label>NIK</label>
                            <input type="text" className="form-control" name="Customer_NIK" value={this.state.Customer_NIK} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row mr-1">
                            <label>NIK Address (Alamat sesuai KTP)</label>
                            <textarea type="text" className="form-control" rows={5} name="Customer_NIK_Address" value={this.state.Customer_NIK_Address} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row mr-1">
                            <label>NPWP</label>
                            <input type="text" className="form-control" name="Customer_NPWP" value={this.state.Customer_NPWP} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row mr-1">
                            <label>NPWP Name</label>
                            <input type="text" className="form-control" name="Customer_NPWP_Name" value={this.state.Customer_NPWP_Name} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row mr-1">
                            <label>NPWP Address</label>
                            <textarea className="form-control" rows={5} name="Customer_NPWP_Address" value={this.state.Customer_NPWP_Address} onChange={this.handleChangeInput.bind(this)}></textarea>
                          </div>
                          <div className="form-group row mr-1">
                            <label>Branch</label>
                            <input type="text" className="form-control" value={this.state.Customer_Branch} disabled={true} />
                            {/* { this.renderLovBranch() } */}
                          </div>
                          <div className="form-group row mr-1">
                            <label>PKP Badan</label>
                            <div className="ml-2 custom-control custom-radio">
                              <input type="radio" id="customRadio1" checked={this.state.Customer_PKP_Badan === 'Y' ? true : false} name="Customer_PKP_Badan" className="custom-control-input" value="Y" onClick={this.handleChangeInput.bind(this)} />
                              <label className="custom-control-label" htmlFor="customRadio1">Ya</label>
                            </div>
                            <div className="ml-2 custom-control custom-radio">
                              <input type="radio" id="customRadio2" checked={this.state.Customer_PKP_Badan === 'N' ? true : false} name="Customer_PKP_Badan" className="custom-control-input" value="N" onClick={this.handleChangeInput.bind(this)} />
                              <label className="custom-control-label" htmlFor="customRadio2">Tidak</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label>PIC (Nama Lengkap sesuai KTP)</label>
                            <input type="text" className="form-control" name="Customer_PIC" value={this.state.Customer_PIC} onChange={(e) => this.setState({Customer_PIC: e.target.value})} />
                          </div>
                          <div className="form-group row">
                            <label>PPh Type</label>
                            {this.renderLovPPhType()}
                          </div>
                          <div className="form-group row">
                            <label>PPh Rate (%)</label>
                            <input type="number" className="form-control" name="Customer_PPh_Rate" value={this.state.Customer_PPh_Rate} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row">
                            <label>Bank Name</label>
                            {this.renderLovBank()}
                          </div>
                          <div className="form-group row">
                            <label>Bank Branch</label>
                            <input type="text" className="form-control" name="Customer_Bank_Branch" value={this.state.Customer_Bank_Branch} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row">
                            <label>Bank Account No</label>
                            <input type="text" className="form-control" name="Customer_Bank_Account_No" value={this.state.Customer_Bank_Account_No} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group row">
                            <label>Bank Account Owner</label>
                            <input type="text" className="form-control" name="Customer_Bank_Account_Owner" value={this.state.Customer_Bank_Account_Owner} onChange={this.handleChangeInput.bind(this)} />
                          </div>
                          <div className="form-group">
                            <label>Upload Document</label><br />
                            {this.renderAttachment()}
                          </div>
                          <div className="form-group row">
                            <label>Notes</label>
                            <textarea className="form-control" onChange={this.handleChangeInput.bind(this)} name="Customer_Notes" rows={5} value={this.state.Customer_Notes}></textarea>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        {this.renderSubmitButton()}
                        <div className="col-md-3">
                          <button type="button" className="btn btn-warning btn-block" onClick={() => { this.props.history.push('/admin/setup/customer/list') }}><i className="fa fa-arrow-left" /> Back</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default CustomerForm